import variables from '../../../scss/variables.json';
import _ from 'lodash';

@Inject('$window', '$rootScope')
class ResponsiveService {
  constructor() {
    this.variables = _.mapValues(variables, (item) => parseInt(item.replace('px')));
    this.currentDeviceFlags = null;
    this.deviceChangeSubscribers = [];
    this.checkDevice();

    this.$window.addEventListener('resize', () => {
      this.checkDevice();
      this.$rootScope.$evalAsync();
    });
  }

  checkDevice() {
    const newDeviceFlags = {
      isPhone: false,
      isTablet: false,
      isMobile: false,
      isDesktop: false,
      isExtraLarge: false,
    };
    const innerWidth = this.$window.innerWidth;
    if (innerWidth <= this.variables['screen-sm-max']) {
      newDeviceFlags.isPhone = true;
      newDeviceFlags.isMobile = true;
    }
    if (innerWidth >= this.variables['screen-md-min'] && innerWidth <= this.variables['screen-md-max']) {
      newDeviceFlags.isTablet = true;
      newDeviceFlags.isMobile = true;
    }
    if (innerWidth >= this.variables['screen-lg-min']) {
      newDeviceFlags.isDesktop = true;
    }
    if (innerWidth >= this.variables['screen-gt-lg']) {
      newDeviceFlags.isExtraLarge = true;
    }
    if (!_.isEqual(newDeviceFlags, this.currentDeviceFlags)) {
      Object.assign(this, newDeviceFlags); // for backward compatibility
      this.currentDeviceFlags = newDeviceFlags;
      this.notifyDeviceChanged();
    }
  }

  /**
   * @todo replace with generic pub-sub solution
   * @param {Function} callback
   * @returns {Function} Unsubscribe function.
   */
  subscribeDeviceChange(callback) {
    this.deviceChangeSubscribers.push(callback);
    return () => {
      _.pull(this.deviceChangeSubscribers, callback);
    };
  }

  notifyDeviceChanged() {
    this.deviceChangeSubscribers.slice().forEach((callback) => callback(this.currentDeviceFlags));
  }
}

export default ResponsiveService;



// WEBPACK FOOTER //
// ./src/modules/utils/responsive/responsive-service.js